<template>
  <div class="content if-profile">
    <IFHeaderProfile :headerData="this.headerData"/>
    <div class="md-layout if-profile-body">
      <div class="md-layout-item p-0">
        <md-card>
          <div class="md-layout md-card if_card">
            <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
              <md-card-header class="md-card-header md-card-header-icon">
                <div class="card_icon">
                  <md-icon>light_mode</md-icon>
                </div>
                About Valuation Multiples
              </md-card-header>
              <div class="md-card-content">
                <div class="extra_space">
                  <p>
                    <b>Business Value Insight Terms</b>: The Bizminer Valuations Value basis is derived from projected company sales; peer group average earnings %; and industry valuation multiples. Median
                    ranges reflect a range of market conditions and business performance at this revenue scale.<br/><br/>
                    You should not use Bizminer Valuations in place of a professional valuation or as the basis of any specific business-related or other financial transaction; nor to secure a
                    business or personal loan.<br/><br/>
                    <b>Owner Earnings (Cash Flow) Approach:</b> Revenue/Owner Earnings market valuation approach<br/><br/>
                    <b>Sales Approach:</b> Revenue/Annual Sales market value approach<br/><br/>
                    <b>Note:</b> Median is the point at which 50% of a sample is above and 50% of the same below the value. Quartile 1 lies at the mid-point between the median and the lowest value; Quartile 3
                    between the median and the highest value.
                  </p>
                  <p>
                    <b>Multiples Definitions:</b>
                    <br>
                    Our multiples are derived from the Dealstats database of more than 30,000 historical business sale transactions. Bizminer cleans and filters the database for locations and anomalies, and applies standard outlier protocols and exclusion calculations to the raw data to determine median and quartile values at the NAICS-4-5-6 levels.
                    <br>
                    The Earning Multiple calculation is:<br>
                    Sale Price / Discretionary Owner Earnings<br>
                    where:<br>
                    Discretionary Owner Earnings = Operating Profit + Owner’s Compensation + Depreciation/Amortization)
                    <br><br>
                    Sale Price is the total consideration paid to the seller and includes any cash, notes, and/or securities that were used as a form of payment plus any interest-bearing liabilities the buyer assumed. The Sale Price includes the non-compete value and the assumption of interest-bearing liabilities and excludes: (1) the real estate value; (2) any earn-outs (because they have not yet been earned and they may not be earned); and (3) the employment/consulting agreement values.
                    <br><br>
                    Asset Sale Note: In an Asset Sale, the assumption is that all or substantially all operating assets are transferred in the sale. In an Asset Sale, the Sale Price may or may not include all current assets, non-current assets, and current liabilities (liabilities are typically not transferred in an asset sale).
                    <br><br>
                    Selling Price: The selling price is the total consideration paid to the seller and includes any cash, notes, and/or securities that were used as a form of payment plus any interest-bearing liabilities the buyer assumed. The selling price includes the non-compete value and the assumption of interest-bearing liabilities and excludes the real estate value; any earn-outs; and the employment/consulting agreement values. In an Asset Sale, the assumption is that all or substantially all operating assets are transferred in the sale.
                    <br><br>
                    <b>Bizminer Valuation Multiples Limitations</b><br>
                    You should not use Bizminer Valuation Multiples or the Toolkit in place of a valuation. Bizminer does not suggest using Valuation Multiples or the Toolkit as the basis of any specific business-related or other financial transaction. You should not attempt to use a Valuation Multiples or other Toolkit elements to secure a business or personal loan. Our data sources may be incomplete or incorrect; nor have we physically researched or inspected many important details necessary to the valuation of a specific enterprise. Neither the Valuation Multiples nor other Toolkit tools consider the market environment details nor the idiosyncrasies of a firm’s performance that can influence the actual value or selling price.
                    <br><br>
                    Multiple values are presented at the most detailed available industry level. In some cases, detailed NAICS or sales group transaction records do not include the minimum number of transactions required for our multiples calculations. In those cases, we may display multiples which reflect values of the directly related NAICS parent industry or sales group. Depending on availability, multiples for one approach (sales or earnings) may reflect a more detailed industry tier than the other.
                    <br><br>
                    We encourage business buyers, sellers, owners and browsers to enhance their understanding of the value of any enterprise before making decisions or taking action. The Valuation Multiples and other Toolkit elements are modeled informational tools, not guides to action. For that we recommend obtaining an appraisal from a business broker, a valuation from a certified valuation professional, or both.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- <md-card-header class="md-card-header-icon">
            <div class="card-icon">
              <md-icon>query_stats</md-icon>
            </div>
            <h4 class="title text-left">
              [238220 Plumbing, Heating, and Air Conditioning Contractors <br />
              <small
                >Valuations are derived from closed business sales as well as
                enterprise-level revenue and industry financial analysis
                developed by Bizminer.
              </small>
            </h4>
          </md-card-header> -->
          <md-card-content class="p-0 negetive_margin">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <!-- <h5 class="title text-left">Firms Analyzed</h5>
                   <h3 class="title text-left section_header">Sales Multiples</h3> -->
                <div class="md-card if_card table_data">
                  <table-card class="md_table m-0">
                    <template slot="header" header-color="rose">
                      <h4 class="title m-0">
                        <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                          Sales Group: &#60; $2.5m
                        </div>
                      </h4>
                    </template>
                    <template slot="content">
                      <md-table
                        v-model="tableInfo"
                        table-header-color="blue"
                      >
                        <md-table-row
                          slot="md-table-row"
                          slot-scope="{ item }"
                        >
                          <md-table-cell md-label="">
                            <div class="md-table-side-label">
                              {{ item.name }}
                            </div>
                          </md-table-cell>
                          <md-table-cell md-label="Sales Multiples">
                            <div class="black-color">
                              {{ multiplesA[`Sales${item.id}`] }}
                            </div>
                          </md-table-cell>
                          <md-table-cell md-label="Earnings Multiples">
                            <div class="black-color">
                              {{ multiplesA[`Earnings${item.id}`] }}
                            </div>
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </template>
                  </table-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <!-- <h5 class="title text-left">Firms Analyzed</h5>
                <h3 class="title text-left section_header">Earnings Multiples</h3> -->
                <div class="md-card if_card table_data">
                  <table-card class="md_table m-0">
                    <template slot="header" header-color="rose">
                      <h4 class="title m-0">
                        <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                          Sales Group: $2.5m - $24.9m
                        </div>
                      </h4>
                    </template>
                    <template slot="content">
                      <md-table
                        v-model="tableInfo"
                        table-header-color="blue"
                      >
                        <md-table-row
                          slot="md-table-row"
                          slot-scope="{ item }"
                        >
                          <md-table-cell md-label="">
                            <div class="md-table-side-label">
                              {{ item.name }}
                            </div>
                          </md-table-cell>
                          <md-table-cell md-label="Sales Multiples"
                            >{{ multiplesB[`Sales${item.id}`] }}
                          </md-table-cell>
                          <md-table-cell md-label="Earnings Multiples"
                            >{{ multiplesB[`Earnings${item.id}`] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </template>
                  </table-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <!-- <h5 class="title text-left">Firms Analyzed</h5> -->
                <div class="md-card if_card table_data">
                  <table-card class="md_table m-0">
                    <template slot="header" header-color="rose">
                      <h4 class="title m-0">
                        <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                          Sales Group: &#62; $25m
                        </div>
                      </h4>
                    </template>
                    <template slot="content">
                      <md-table
                        v-model="tableInfo"
                        table-header-color="blue"
                      >
                        <md-table-row
                          slot="md-table-row"
                          slot-scope="{ item }"
                        >
                          <md-table-cell md-label="">
                            <div class="md-table-side-label">
                              {{ item.name }}
                            </div>
                          </md-table-cell>
                          <md-table-cell md-label="Sales Multiples"
                            >{{ multiplesC[`Sales${item.id}`] }}
                          </md-table-cell>
                          <md-table-cell md-label="Earnings Multiples"
                            >{{ multiplesC[`Earnings${item.id}`] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </template>
                  </table-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <!-- <h5 class="title text-left">Firms Analyzed</h5> -->
                <div class="md-card if_card table_data">
                  <table-card class="md_table m-0">
                    <template slot="header" header-color="rose">
                      <h4 class="title m-0">
                        <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                          Sales Group: All
                        </div>
                      </h4>
                    </template>
                    <template slot="content">
                      <md-table
                        v-model="tableInfo"
                        table-header-color="blue"
                      >
                        <md-table-row
                          slot="md-table-row"
                          slot-scope="{ item }"
                        >
                          <md-table-cell md-label="">
                            <div class="md-table-side-label">
                              {{ item.name }}
                            </div>
                          </md-table-cell>
                          <md-table-cell md-label="Sales Multiples"
                            >{{ multiplesAll[`Sales${item.id}`] }}
                          </md-table-cell>
                          <md-table-cell md-label="Earnings Multiples"
                            >{{ multiplesAll[`Earnings${item.id}`] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </template>
                  </table-card>
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>


    </div>
  </div>
</template>

<script>
import { TableCard } from '@/components';
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';
import IFHeaderProfile from './IFHeaderProfile';

export default {
  components: {
    TableCard,
    IFHeaderProfile,
   },
  mixins: [formatData],
  props:['headerData'],
  data() {
    return {
      tableInfo: [
        {
          id: 'Low',
          name: 'Q1',
        },
        {
          id: 'Med',
          name: 'Median',
        },
        {
          id: 'High',
          name: 'Q3',
        },
      ],
      filtered_years: [],
      filtered_firms: [],
      filtered_PLDollar: [],
      filtered_PLPercent: [],
      filtered_BSDollar: [],
      filtered_BSPercent: [],
      cashflow: [],
      cashFlowFilteredData: [],
      efficiency: [],
      efficiencyFilteredData: [],
      profitability: [],
      profitabilityFilteredData: [],
      turnover: [],
      debtRiskFilteredData: [],
      changein: [],
      changeinFilteredData: [],
      worksheet: [],
      worksheetFilteredData: [],
      sales_class_csv: '',
    };
  },
  computed: {
    ...mapState({
      multiplesA: (state) => {
        return state.user.profile['multiples_A']
          ? state.user.profile['multiples_A']
          : [];
      },
      multiplesB: (state) => {
        return state.user.profile['multiples_B']
          ? state.user.profile['multiples_B']
          : [];
      },
      multiplesC: (state) => {
        return state.user.profile['multiples_C']
          ? state.user.profile['multiples_C']
          : [];
      },
      multiplesAll: (state) => {
        return state.user.profile['multiples_all']
          ? state.user.profile['multiples_all']
          : [];
      },
      data: (state) => state.user.profile.data,
      profile: (state) => state.user.profile,
      PLtable: (state) => state.user.profile.tables['PL'],
      BStable: (state) => state.user.profile.tables['BS'],
      tables: (state) => state.user.profile.tables['ratios'],
      tablesInfo: (state) => state.user.profile.tables['ratioInfo'],
      sourcesUses: (state) => state.user.profile['sourcesUses'],
      sourceYears: (state) => state.user.profile['sourcesUses']['years'],
      release_display: (state) => state.user.profile.release_display,
      bznaics_code: (state) => state.user.profile.bznaics,
      sector_name: (state) => state.user.profile.data[0].sector,
      industry_title: (state) => state.user.profile.data[0].industry,
      sales_class: (state) => state.user.profile.data[0].sales_class,
      display_area: (state) => state.user.profile.data[0].display_area,
    }),
    sourceTablesInfo() {
      return _.omit(this.sourcesUses, 'years');
    },
    filteredProfile() {
      return Object.values(this.profile.data).filter((item) => item);
    },
    getCsvData() {
      let csvData = [
        ['Industry Financial Report'],
        ['"Release Date"', this.release_display],
        [''],
        ['Segment', 'Industry'],
        [this.industry_title],
        ['[' + parseInt(this.bznaics_code) + ']' + ' Sector', this.sector_name],
        ['Market', this.display_area],
        ['Sales Class', this.sales_class_csv],
        [''],
      ];
      csvData.push(['Firms Analyzed', this.filtered_years]);
      csvData.push(['', this.filtered_firms]);
      csvData.push(['']);
      csvData.push(['Income and Expense - Profit and Loss($)']);
      csvData.push(['', this.filtered_years]);
      this.filtered_PLDollar.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Income and Expense - Profit and Loss(%)']);
      csvData.push(['', this.filtered_years]);
      this.filtered_PLPercent.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Balance Sheet($)']);
      csvData.push(['Assets', this.filtered_years]);
      this.filtered_BSDollar.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Balance Sheet(%)']);
      csvData.push(['Assets', this.filtered_years]);
      this.filtered_BSPercent.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Financial Ratios: Cash Flow-Solvency']);
      csvData.push(['', this.filtered_years]);
      this.cashFlowFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Profitability']);
      csvData.push(['', this.filtered_years]);
      this.profitabilityFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Efficiency']);
      csvData.push(['', this.filtered_years]);
      this.efficiencyFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Debt-Risk']);
      csvData.push(['', this.filtered_years]);
      this.debtRiskFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Sources & Uses of Funds']);
      csvData.push(['', this.sourceYears]);
      this.changeinFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['Worksheet:']);
      this.worksheetFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      return csvData;
    },
    filteredData() {
      return Object.values(this.data).filter((item) => item);
    },
    actualData() {
      return this.filteredData[0]['cashflow'];
    },
  },
  mounted() {
    this.profile.years.forEach((e, i) => {
      this.filtered_years.push(Number(e));
    });
    let firmData = Object.values(this.profile.data)
      .filter((item) => item)
      .map((item) => ({ ...item, firms: item.firms }));

    firmData.forEach((element) => {
      this.filtered_firms.push(parseFloat(element.firms));
    });
    if (this.sales_class.includes(',')) {
      this.sales_class_csv = this.sales_class.replace(/,/g, '');
    }
    let PLdollar = this.formatTable(this.PLtable, 'industry', 'dollar');
    let PLpercent = this.formatTable(this.PLtable, 'industry', 'percent');

    PLdollar.forEach((element) => {
      if (element.name.includes(',')) {
        element.name = element.name.replace(/,/g, '');
      }
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });
      v.unshift(element.name);
      this.filtered_PLDollar.push(v);
    });
    PLpercent.forEach((element) => {
      if (element.name.includes(',')) {
        element.name = element.name.replace(/,/g, '');
      }
      let z = Object.values(element.dates);
      let v = [];
      z.forEach((item, i) => {
        if (typeof item === 'string' && item.includes(',')) {
          item = parseFloat(item.replace(/,/g, ''));
        }
        v.push(item);
      });
      v.unshift(element.name);
      this.filtered_PLPercent.push(v);
    });

    let BSdollar = this.formatTable(this.BStable, 'industry', 'dollar');
    let BSpercent = this.formatTable(this.BStable, 'industry', 'percent');

    BSdollar.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.name);
      this.filtered_BSDollar.push(v);
    });
    BSpercent.forEach((element) => {
      let z = Object.values(element.dates);
      let v = [];
      z.forEach((item, i) => {
        if (typeof item === 'string' && item.includes(',')) {
          item = parseFloat(item.replace(/,/g, ''));
        }
        v.push(item);
      });
      v.unshift(element.name);
      this.filtered_BSPercent.push(v);
    });

    if (!_.isEmpty(this.tables)) {
      Object.entries(this.tables).forEach(
        ([table, data]) => this.$set(this, table, this.formatTable(data, 'industry'))
      );
    }
    let cashFlowData = [];
    this.cashflow.forEach((element, index) => {
      if (element.name in this.tables['cashflow']) {
        cashFlowData.push({
          dates: element.dates,
          title: this.tablesInfo[element.name]['title'],
        });
      }
    });
    cashFlowData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.cashFlowFilteredData.push(v);
    });

    let efficiencyData = [];
    this.efficiency.forEach((element, index) => {
      if (element.name in this.tables['efficiency']) {
        efficiencyData.push({
          dates: element.dates,
          title: this.tablesInfo[element.name]['title'],
        });
      }
    });
    efficiencyData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.efficiencyFilteredData.push(v);
    });

    let profitabilityData = [];
    this.profitability.forEach((element, index) => {
      if (element.name in this.tables['profitability']) {
        profitabilityData.push({
          dates: element.dates,
          title: this.tablesInfo[element.name]['title'],
        });
      }
    });
    profitabilityData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.profitabilityFilteredData.push(v);
    });

    let debtRiskData = [];
    this.turnover.forEach((element, index) => {
      if (element.name in this.tables['turnover']) {
        debtRiskData.push({
          dates: element.dates,
          title: this.tablesInfo[element.name]['title'],
        });
      }
    });
    debtRiskData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.debtRiskFilteredData.push(v);
    });

    Object.entries(this.sourceTablesInfo).forEach(([table, data]) =>
      this.$set(this, table, this.formatSourcesData(table, data))
    );

    this.changein.forEach((element, index) => {
      let k = [];
      Object.values(element.dates).forEach((e, index) => {
        k.push(e);
      });
      k.unshift(element.title);
      this.changeinFilteredData.push(k);
    });
    this.worksheet.forEach((element, index) => {
      let k = [];
      Object.values(element.dates).forEach((e, index) => {
        k.push(e);
      });
      k.unshift(element.title);
      this.worksheetFilteredData.push(k);
    });
  },
  methods: {
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += '\n';
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Industry Financial Profile.csv';
      anchor.click();
    },
    formatSourcesData(table, data) {
      let getDates = (id) =>
        this.sourceYears.reduce((acc, cur, index) => {
          let value = this.actualData[this.sourceYears.length - index - 1][id];

          value = isNaN(Number(value)) ? value : Number(value.toFixed(0));

          return { ...acc, [cur]: value };
        }, {});

      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },
  },
};
</script>
<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}

.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}

.md-table[table-header-color=blue] .md-table-head .md-table-head-label, .md-table[table-header-color=blue] .md-table-side-label{
  color: black !important;
  font-size: 13px !important;
}
.if-profile .if_card .md-card-header .card_icon {
  background-color: #002277 !important;
}

</style>
